import { createSelector } from '@reduxjs/toolkit'

export const getDeductionSummarySlice = (state) => state.deductionSummary

export default createSelector([getDeductionSummarySlice], (deductionSummary) => ({
    deductionSummary,
    deductionSummaryStatus: deductionSummary.status,
    hasDeductionSummary: !!deductionSummary.taxReturnId,
}))
